import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';

import ClientWebsiteStore from '../../stores/ClientWebsiteStore';
import UserStore from '../../stores/UserStore';

import HostingActions from '../../actions/HostingActions';

function getState() {
    return {
        websites: ClientWebsiteStore.get(),
        loading: ClientWebsiteStore.loading()
    };
}

const WebsiteTable = React.createClass({
    componentDidMount: function() {
        ClientWebsiteStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        ClientWebsiteStore.removeChangeListener(this._onChange);
    },
    getInitialState: function () {
        return getState();
    },
    render: function () {
        return <section className="powerwidget green">
            <div className="inner-spacer">
                <p>
                    This is a list of your websites that are currently hosted with Infinite Networks.
                    It is generated by a script that scans our hosting servers, and may contain inaccuracies.
                </p>
                <div className="table-responsive">
                    <Table className="table-striped table-hover">
                        <thead><tr>
                            <th>Website</th>
                            <th>Type</th>
                            <th>Info</th>
                            <th>Server</th>
                        </tr></thead>
                        <tbody>
                            {this.state.websites.map(w => <tr key={w.domain}>
                                <td><a href={'http://' + w.domain} target="_blank">{w.domain}</a></td>
                                <td>{w.redirectsTo ? 'Redirect' : 'Website'}</td>
                                <td>
                                    {w.redirectsTo && <div>
                                        Redirects to {w.redirectsTo}
                                    </div>}
                                    {w.aliases.length > 0 && <div>
                                        <em>Aliases:</em>
                                        {w.aliases.map(a => <div key={a}>{a}</div>)}
                                    </div>}
                                </td>
                                <td>{w.serverName}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </div>
            </div>
        </section>;
    },
    _onChange: function() {
        this.setState(getState());
    }
});

module.exports = WebsiteTable;



// WEBPACK FOOTER //
// ./app/components/Hosting/WebsiteTable.js